import LandingHeader from 'components/Common/LandingHeaderV2';
import React from 'react';
import bigImg from 'assets/images/gen-ai-image-landing/big.jpg';
import bigImg2 from 'assets/images/gen-ai-image-landing/big2.jpg';
import Footer from 'components/Landing/Footer';
import Hero from './Hero';
import Hey from './Hey';
import ForEveryone from './ForEveryone';
import HowItWorks from './HowItWorks';
import Testimonial from './Testimonial';
import Magic from './Magic';
import styles from './GenAIImageLanding.module.scss';
import TryNow from './TryNow';

export default function GenAIImageLanding() {
  return (
    <div className={styles.container}>
      <LandingHeader />
      <Hero />
      <Hey />
      <img src={bigImg} alt="big" className={styles.bigImg} />
      <ForEveryone />
      <HowItWorks />
      <Testimonial />
      <Magic />
      {/* <ApiAccess /> */}
      <img
        src={bigImg2}
        alt="big"
        className={styles.bigImg}
      />
      <TryNow />
      <Footer />
    </div>
  );
}
